import { SimpleGrid } from "@chakra-ui/react";
import UTMLink from "@components/UTMLink";
import { trackEvent } from "utils";
import { Section, Title } from "../utils";
import SecurityCard from "./SecurityCard";
import { LP_SECURITY } from "@constants/analytics";

export type SecurityData = {
  title: string;
  subTitle: string;
  bgImg: string;
  link: string;
};

const SECURITY_DATA = [
  {
    title: "Audits",
    subTitle: "Protected and Verified by trusted auditors",
    bgImg: "/assets/audits/audits.svg",
    link: "https://kerneldao.gitbook.io/kernel/getting-started/kelp/audits/",
  },
  {
    title: "Bug Bounty",
    subTitle: "Secure Kelp, earn up to $250K",
    bgImg: "/assets/audits/bounty.svg",
    link: "https://immunefi.com/bug-bounty/kelp-dao/information/",
  },
];

const Security = () => {
  return (
    <Section>
      <Title>Security</Title>
      <SimpleGrid spacing="24px" columns={{ sm: 1, md: 2 }}>
        {SECURITY_DATA.map((data) => (
          <UTMLink
            href={data.link}
            isExternal
            _hover={{
              borderBottom: "none",
            }}
            onClick={() => {
              trackEvent(LP_SECURITY, {
                name: data.title,
              });
            }}
            key={data.title}
          >
            <SecurityCard security={data} />
          </UTMLink>
        ))}
      </SimpleGrid>
    </Section>
  );
};

export default Security;
